export default __webpack_public_path__ + "static/media/signup.62901ff3.svg";